import React, { useState } from 'react';
import { 
  FormContainer, 
  StyledTextarea, 
  SubmitButton, 
  TextareaWrapper,
  CharacterCount,
  ExampleButton,
  ExampleList,
  FormGuide,
  ValidationMessage
} from './DreamFormStyles';

const dreamExamples = [
  '돼지가 집으로 들어오는 꿈',
  '큰 뱀에게 쫓기다가 도망친 꿈',
  '돌아가신 가족을 만나 대화한 꿈'
];

function DreamForm({ onSubmit, disabled = false }) {
  const [dream, setDream] = useState('');
  const [validationMessage, setValidationMessage] = useState('');
  const maxLength = 400;

  const handleChange = (e) => {
    const text = e.target.value;
    if (text.length > maxLength) {
      alert('400자 미만으로 작성해주세요');
      setDream(text.slice(0, maxLength));
    } else {
      setDream(text);
    }
    if (text.trim()) setValidationMessage('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedDream = dream.trim();

    if (!trimmedDream) {
      setValidationMessage('해석할 꿈 내용을 한 문장 이상 입력해주세요.');
      return;
    }

    onSubmit(trimmedDream);
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <TextareaWrapper>
        <StyledTextarea
          value={dream}
          onChange={handleChange}
          placeholder="누가, 어디서, 무엇을 했는지 자세히 적을수록 풍부한 해석을 받을 수 있어요."
          maxLength={maxLength}
          aria-describedby="dream-guide dream-error"
          disabled={disabled}
        />
        <CharacterCount>{dream.length}/{maxLength}</CharacterCount>
      </TextareaWrapper>
      <FormGuide id="dream-guide">기억나는 장면을 눌러 예시로 시작해보세요.</FormGuide>
      <ExampleList aria-label="꿈 내용 예시">
        {dreamExamples.map((example) => (
          <ExampleButton
            key={example}
            type="button"
            onClick={() => {
              setDream(example);
              setValidationMessage('');
            }}
            disabled={disabled}
          >
            {example}
          </ExampleButton>
        ))}
      </ExampleList>
      <ValidationMessage id="dream-error" role="alert">{validationMessage}</ValidationMessage>
      <SubmitButton type="submit" disabled={disabled}>
        {disabled ? '꿈을 해석하고 있어요…' : '무료로 꿈 해석하기'}
      </SubmitButton>
    </FormContainer>
  );
}

export default DreamForm;
